"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            DialogPopup_Close: "Close the popup",
        },
    });
    var controls;
    (function (controls) {
        /**
         * Framework base class for DropDialogPopup form controls
         */
        var DropDialogPopup = /** @class */ (function (_super) {
            __extends(DropDialogPopup, _super);
            function DropDialogPopup() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return DropDialogPopup;
        }($dyn.controls.Popup));
        controls.DropDialogPopup = DropDialogPopup;
        // tslint:disable:object-literal-sort-keys
        var DropDialogShortcuts = {
            DefaultAction: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    // If a form is being rendered as a drop dialog and has DefaultAction specified, it will take precedence over DefaultButton.
                    this.executeDefaultActionOrDefaultButton(evt);
                },
                ShowToUser: false,
            },
            DefaultActionAlternate: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    // If a form is being rendered as a drop dialog and has DefaultAction specified, it will take precedence over DefaultButton.
                    this.executeDefaultActionOrDefaultButton(evt);
                },
                Description: function () {
                    var description = "";
                    if ($dyn.value(this.DefaultActionEnabled)) {
                        description = $dyn.label("Form_DefaultAction");
                    }
                    else {
                        description = $dyn.label("Dialog_DefaultButton");
                    }
                    return description;
                },
            },
            Escape: {
                Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                Handler: function (evt) {
                    // When using this shortcut from an element just edited, the control may not have the latest value
                    var control = evt ? $dyn.context(evt.target) : undefined;
                    if (control && control.updateValue) {
                        control.updateValue(true);
                    }
                    this.AllowSave($dyn.shell.initiateBack);
                },
                Description: $dyn.label("DialogPopup_Close"),
                Category: $dyn.ui.ShortcutCategory.Close,
            },
        };
        DropDialogPopup.prototype.Shortcuts = $dyn.extendPrototype(DropDialogPopup.prototype.Shortcuts, DropDialogShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DropDialogPopup.js.map
